import React from "react";

const QrCode = ({ base64Image }) => {
  if (!base64Image) {
    return null;
  }

  const src = base64Image.startsWith("data:")
    ? base64Image
    : `data:image/png;base64,${base64Image}`;

  return (
    <div className="text-center my-3">
      <img
        src={src}
        alt="MFA QR Code"
        style={{ maxWidth: "220px", width: "100%", height: "auto" }}
      />
    </div>
  );
};

export default QrCode;
